/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { initHubSpotFormStitching } from './src/utils/trackFormSubmit'

const TAPESTRY_FORM_NAMES = {
    'c58eb1a8-9e08-46b9-9503-19d2c5342bbc': 'tapestry_enquire',
}

export const onClientEntry = () => {
    initHubSpotFormStitching(TAPESTRY_FORM_NAMES)
}

export const onRouteUpdate = ({ location }) => {
    window.dataLayer.push({
        'event': 'page_view',
        'pathname': location.pathname
    })
}
